import isCore from 'common/util/isCore';
import isGrowth from 'common/util/isGrowth';
import isPro from 'common/util/isPro';
import isStarter from 'common/util/isStarter';

import type { PlanTrial } from 'common/api/endpoints/companies';

const getPlanNameForTrial = (trialingPlan: Pick<PlanTrial, 'planID'>) => {
  const { planID } = trialingPlan;

  if (isCore(planID)) {
    return 'Core';
  }

  if (isPro(planID)) {
    return 'Pro';
  }

  if (isStarter(planID)) {
    return 'Starter';
  }

  if (isGrowth(planID)) {
    return 'Growth';
  }

  if (planID === 'business-trial-1') {
    return 'Business';
  }

  return 'Legacy';
};

export default getPlanNameForTrial;
